module.exports = __webpack_public_path__ + "img/404.c980fa0b.svg";